import { ProductionStatementCreationJob } from "@/models/production-statement-creation-job.model"
import { defineStore } from "pinia"
import { ref, type Ref } from "vue"

export const useProductionStatementCreationJobStore = defineStore(
  "productionStatementCreationJobsStore",
  () => {
    const productionStatementCreationJobs: Ref<ProductionStatementCreationJob[]> = ref([])

    return {
      productionStatementCreationJobs
    }
  }
)
